module.exports = __webpack_public_path__ + "static/media/qantas-freight.d52e8f83.svg";